import styled from "styled-components";

export const FirstDiv = styled.div`
  background-color: ${({ theme }) => theme.colors.primary500};
  height: 100%;
  width: 99%;
  padding: 4rem 8rem;
  margin: 0.5rem 0.5rem 0rem 0.5rem;
  border-radius: 20px 20px 0px 0px;

  @media screen and (max-width: 768px) {
    padding: 2rem 1rem;
  }
`;

export const ButtonDiv = styled.div`
  max-width: 15rem;
`;

export const StartDiv = styled.div`
  margin-top: 5rem;
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
`;

export const BreakDiv = styled.div`
  display: flex;
  flex-direction: column;
`;

export const DatesSecondDiv = styled.div`
  display: flex;
  gap: 1rem;

  @media screen and (max-width: 768px) {
    flex-direction: column;
    gap: 0.8rem;
  }
`;

export const Line = styled.div`
  min-height: 62px;
  min-width: 1px;
  background-color: ${({ theme }) => theme.colors.primary200};

  @media screen and (max-width: 768px) {
    min-height: 1px;
    width: 100%;
  }
`;

export const ColumnDiv = styled.div`
  display: flex;
  flex-direction: column;
`;

export const FiltersContainer = styled.div`
  display: flex;
  gap: 1rem;
  justify-content: flex-end;
  align-items: center;
`;

export const SecondDiv = styled.div`
  background-color: ${({ theme }) => theme.colors.primary100};
  height: 100%;
  width: 99%;
  border-radius: 20px 20px 20px 20px;
  padding: 4rem 8rem;
  margin: -1rem 0.5rem 0rem 0.5rem;

  @media screen and (max-width: 768px) {
    padding: 2rem 1rem;
  }
`;
